/* 🤖 this file was generated by svg-to-ts */
export const siriusCaretDown: {
  name: 'caret_down';
  data: string;
} = {
  name: 'caret_down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.97 8.47a.75.75 0 0 1 1.06 0L12 15.44l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 0-1.06Z" fill="currentColor"/></svg>`
};
